import {
  getEmployeePositionNumberBySlot,
  getEmployeePositionSlotByNumber,
} from "~/entity/Employee/lib/restGaps";

import {
  IEmployeeProfileForm,
  TDealerFormItem,
  TPositionFormItem,
} from "./types";

export const getNextPositionSlotIndex = (
  positions: TPositionFormItem[],
): number => {
  const usedNumbers = new Set(
    positions.map((position) =>
      getEmployeePositionNumberBySlot(position.number),
    ),
  );
  let index = 0;

  while (usedNumbers.has(index + 1)) {
    index += 1;
  }

  return index;
};

export const defaultValueDealer = (): TDealerFormItem => ({
  dealer: null,
  organizationType: "DEALER",
  email: "",
  emailVerification: false,
  dataConsentId: "",
  status: "",
  lastStatusUpdateAt: "",
  lastStatusUpdateByUser: "",
  positionOrderId: "",
  startDate: null,
  startOrderNumber: "",
  hired: "",
  endDate: null,
  endOrderNumber: "",
  dismissalOrderId: "",
  jobDescriptionId: "",
});

export const defaultValuePosition = (index: number): TPositionFormItem => ({
  number: getEmployeePositionSlotByNumber(index + 1),
  position: null,
  licenseAssigned: false,
  licenseFreeCount: 0,
  dealers: [defaultValueDealer()],
  isNew: true,
});

export const getDefaultFormValues = (): IEmployeeProfileForm => ({
  name: "",
  surname: "",
  middleName: "",
  noMiddleName: false,
  gender: "Male",
  birthDay: null,
  workPhone: "",
  photoId: "",
  ladaAcademiaId: "",
  resourcesControlUserId: "",
  createdAt: null,
  lastEditDate: null,
  hiredDate: null,
  positions: [defaultValuePosition(0)],
});
